import { render, staticRenderFns } from "./chooseDeviceBrandDialog.vue?vue&type=template&id=bc33c614&scoped=true"
import script from "./chooseDeviceBrandDialog.vue?vue&type=script&lang=js"
export * from "./chooseDeviceBrandDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseDeviceBrandDialog.vue?vue&type=style&index=0&id=bc33c614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33c614",
  null
  
)

export default component.exports